import { $authHost } from ".."

export const getContractsAllAPI = async () => {
    const {data} = await $authHost.get(`api/contracts/all`)
    return data
}